export default __webpack_public_path__ + "locales/ru/Settings.json?hash=ff98a3cdd451c2b8f22430554e04c244";